module.exports = __webpack_public_path__ + "static/zen-c54ccce6a95af0163da2ba0c3958bcf0.png";